import React from 'react';
import { SvgProps, Svg } from '../../Svg';

const Icon: React.FC<SvgProps> = () => {
  return (
    <Svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.4062 16.3364H6.51419C6.33619 16.3364 6.1922 16.1914 6.1922 16.0144V6.63235C6.1922 6.45435 6.33719 6.31036 6.51419 6.31036H15.8972C16.0752 6.31036 16.2182 6.45535 16.2182 6.63235V10.5254C16.2182 10.9954 16.5992 11.3764 17.0692 11.3764C17.5392 11.3764 17.9202 10.9954 17.9202 10.5254V6.63235C17.9202 5.51735 17.0132 4.60938 15.8982 4.60938H6.5152C5.4002 4.60938 4.49219 5.51735 4.49219 6.63235V16.0144C4.49219 17.1294 5.4002 18.0374 6.5152 18.0374H10.4072C10.8772 18.0374 11.2582 17.6564 11.2582 17.1864C11.2582 16.7164 10.8762 16.3364 10.4062 16.3364Z"
        fill="#A3A3A3"
      />
      <path
        d="M17.0761 19.0585C18.1105 19.0585 18.9491 18.2199 18.9491 17.1855C18.9491 16.1511 18.1105 15.3125 17.0761 15.3125C16.0417 15.3125 15.2031 16.1511 15.2031 17.1855C15.2031 18.2199 16.0417 19.0585 17.0761 19.0585Z"
        fill="#A3A3A3"
      />
    </Svg>
  );
};

export default Icon;
